import { styles } from 'consts';
import styled from 'styled-components';

const {
  progressBarGradient,
  progressBarFill,
  graySecondary,
  fontMontserrat,
  progressPlaceholderDark,
  progressBarTransition,
} = styles;

interface IProps {
  progress: number;
}

export const ProgressBarWrapper = styled.div`
  margin-bottom: 1.3125rem;
  position: relative;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const ProgressStatus = styled.div`
  color: ${progressBarFill};
  font-family: ${fontMontserrat};
  font-size: 0.8125rem;
  font-weight: 300;
  margin-bottom: 0.5rem;
  height: 0.875rem;
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
`;

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  progress: number;
  mobile?: boolean;
}

const getWidth = ({ progress }: IProps) => progress;
const setHeight = ({ mobile }: ProgressProps) => (mobile ? 'height: 0.25rem;' : '');

export const Progress = styled.div.attrs<ProgressProps>(({ progress = 0, mobile = false }) => ({
  progress,
  mobile,
}))<ProgressProps>`
  height: 0.3125rem;
  border-radius: 0.0625rem;
  background: ${progressBarGradient};
  transition: width 1s;
  width: ${getWidth}%;
  position: absolute;
  ${setHeight}
`;

interface ProgressPlaceholderProps extends React.HTMLAttributes<HTMLDivElement> {
  dark?: boolean;
}

const dark = (p: ProgressPlaceholderProps) =>
  p.dark &&
  `
    background-color: ${progressPlaceholderDark};
    height: 0.25rem;
  `;

export const ProgressPlaceholder = styled.div<ProgressPlaceholderProps>`
  height: 0.3125rem;
  border-radius: 0.0625rem;
  background-color: ${graySecondary};
  transition: ${progressBarTransition};
  width: 100%;
  ${dark}
`;
